<template>
	<div class="i-currency-input">
		<label>{{label}}</label>
		<tabs size="xs">
			<tab :title="curr" :key="curr" v-for="(curr,i) in currs" :style="{color:colors[i]}" :padding="0" >
				<inputi type="number" label="" :value="data[curr]" class="input-mini" @input="(v)=>change(curr,v)"/>
			</tab>
		</tabs>
		<!-- 
		<table border="1">
			<tr>
				<td v-for="(curr,i) in Object.keys(value)" v-if="value[curr]!=0" :style="{color:colors[i]}">
					{{curr}}: {{value[curr]}}
				</td>
			</tr>
		</table> -->
	</div>
</template>

<script>
export default {
  props:{
  	"value":{type:Object,default(){return {}}},
  	"label":{type:String,default:''},
  },
  name: 'i-currency-input',
  methods:{
  	change(curr,v){
  		//let newValue = _i.clone(this.data);
  		this.data[curr] = v;
  		this.$emit('input',this.data);
  	}
  },
  mounted(){
  	if( typeof this.value != "object"){
  		this.data = {};
  	} else {
  		this.data = this.value;
  	}
  },
  data () {
    return {
    	data:{},
    	colors:["#7ED321","#FF4D4D","#4A90E2","#9013FE","#FFF46A"]
    }
  }
}
</script>

<style lang="css" scoped>
label{
	font-weight: bold;
	margin-bottom: 4px;
	display: block;
}

.i-currency-input{
	margin-bottom: 12px;
}
.i-currency{
	display: inline-block;
}
table{
	border-collapse: collapse;
}

.input-mini{
	padding:0;
	margin:0;
	margin-top:-1px;
}
</style>
<style lang="css">
	.i-currency-input .inputi{
	border-top-right-radius: 0;
	border-top-left-radius: 0;
}
</style>